<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <path fill-rule="evenodd" d="M22 2H2v20h20V2ZM0 0v24h24V0H0Z"/>
</svg>
